import { jsx as l, jsxs as f } from "react/jsx-runtime";
import { memo as x, useMemo as s, useCallback as I } from "react";
import { menuItemClasses as c, ListItemIcon as S, ListItemText as b } from "@mui/material";
import { LANGUAGE_SELECT_OPTIONS as h } from "./constants19.mjs";
import { SelectInnerRenderValue as L } from "./SelectInnerRenderValue.mjs";
import { Typography as $ } from "./index59.mjs";
import { ArrowIcon as v, Select as C, LanguageSelectOption as M } from "./styles16.mjs";
const P = {
  sx: {
    marginTop: (r) => r.spacing(0.5)
  },
  slotProps: {
    paper: {
      sx: (r) => ({
        borderRadius: r.tokens.radius[8],
        backgroundColor: r.palette.background.level3,
        boxShadow: r.shadows[1]
      })
    }
  },
  MenuListProps: {
    sx: {
      padding: 0.5,
      display: "flex",
      flexDirection: "column",
      gap: 1,
      [`.${c.root}`]: {
        margin: 0,
        [`&.${c.selected}`]: {
          color: (r) => r.palette.text.primary
        }
      }
    }
  }
}, O = x(
  ({
    options: r = h,
    value: i,
    onChange: m,
    background: a = "dark",
    fullWidth: u,
    ...d
  }) => {
    const n = s(() => r.reduce((e, o) => (e[o.value] = o, e), {}), [r]), p = I(
      (e) => /* @__PURE__ */ l(L, { selected: e, optionsMap: n }),
      [n]
    ), g = s(
      () => (e) => /* @__PURE__ */ l(v, { ...e, $background: a }),
      [a]
    );
    return /* @__PURE__ */ l(
      C,
      {
        value: i,
        onChange: m,
        MenuProps: P,
        IconComponent: g,
        size: "small",
        $background: a,
        $fullWidth: u,
        renderValue: p,
        ...d,
        children: r.map((e) => {
          const o = e.flag, t = `${e.value}-flag`;
          return /* @__PURE__ */ f(M, { value: e.value, children: [
            /* @__PURE__ */ l(
              S,
              {
                title: t,
                "aria-label": t,
                sx: { borderRadius: 4 },
                children: /* @__PURE__ */ l(o, {})
              }
            ),
            /* @__PURE__ */ l(b, { children: /* @__PURE__ */ l($.Caption, { display: "flex", alignItems: "center", children: e.label }) })
          ] }, e.value);
        })
      }
    );
  }
);
export {
  O as LanguageSelect
};
//# sourceMappingURL=index35.mjs.map
